import Page from "$routes/price-list/_lib/components/page-layout";
import { linkToPriceListHome } from "$routes/price-list/links";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { Navigate, useParams } from "react-router-dom";
import CreateCustomItemsForm from "./_lib/create-custom-items-form";

const CreateCustomItemsPage: FC = () => {
  const { id: priceListId } = useParams();

  if (!priceListId) {
    return <Navigate to={linkToPriceListHome()} />;
  }

  return (
    <Page>
      <Typography variant="h2">
        <FormattedMessage
          id="pricelist.createCustomItems.header.title"
          defaultMessage="Custom Items List"
        />
      </Typography>
      <CreateCustomItemsForm priceListId={priceListId} />
    </Page>
  );
};

export default CreateCustomItemsPage;
